<template>
    <v-form v-model="valid" ref="newIntent">
        <v-container fluid style="min-height: 0;">
            <v-layout>
                <v-flex xs12>
                    <v-card>
                        <v-card-title column primary-title>
                            <v-text-field
                                label="Issuer"
                                hint="pulled from your profile"
                                :disabled="true"
                                :required="true"
                                :value="intent.Issuer"
                            ></v-text-field>
                            <v-text-field
                                ref="code"
                                label="Code will be generated..."
                                hint="Code will be generated..."
                                :disabled="true"
                                :required="true"
                                :value="intent.Code"
                                @input="updateCode"
                            ></v-text-field>
                        </v-card-title>

                        <v-card-text>
                            <v-text-field
                                ref="shortDescription"
                                label="Short description"
                                hint="What will the data be used for?"
                                :value="intent.ShortDescription"
                                @input="updateShortDescription"
                            ></v-text-field>
                            <v-text-field
                                multi-line
                                ref="description"
                                label="Description"
                                hint="What will the data be used for?"
                                :value="intent.Description"
                                @input="updateDescription"
                            ></v-text-field>
                            <v-select
                                ref="scopes"
                                label="Scopes"
                                hint="What data will be retrieved?"
                                multiple
                                chips
                                autocomplete
                                cache-items
                                :async-loading="loadingScopes"
                                :value="intent.Scopes"
                                :items="loadedScopes"
                                :search-input.sync="searchScopes"
                                @input="updateScopes"
                            ></v-select>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn flat @click="clear">Clear</v-btn>
                            <v-btn flat primary :class="{ disabled: !valid }" @click="add">Add intent</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'intentsNew',
        data() {
            return {
                title: 'New Intent',
                valid: false,
                searchScopes: undefined,
            };
        },
        computed: {
            ...mapState('intents', {
                intent: state => state.intent,
                loadedScopes: state => state.scopes.found,
                loadingScopes: state => state.scopes.loading,
            }),
        },
        watch: {
            searchScopes(value) {
                if (value) {
                    this.queryScopes(value);
                }
            },
        },
        methods: {
            add() {
                if (this.$refs.newIntent.validate()) {
                    this.$store.dispatch('intents/SAVE');
                }
            },
            clear() {
                this.$refs.newIntent.reset();
            },
            updateCode(value) {
                this.$store.commit('intents/UPDATE_CODE', value);
            },
            updateShortDescription(value) {
                this.$store.commit('intents/UPDATE_SHORT_DESCRIPTION', value);
            },
            updateDescription(value) {
                this.$store.commit('intents/UPDATE_DESCRIPTION', value);
            },
            updateScopes(value) {
                this.$store.commit('intents/UPDATE_SCOPES', value);
            },
            queryScopes(value) {
                this.$store.dispatch('intents/QUERY_SCOPES', value);
            },
        },
        created() {
            this.$store.commit('nav/BREADCRUMBS', [
                { id: 'intents', text: 'Intents', to: '/intents' },
                { id: 'intents-new', text: 'new', to: '/intents/new' },
            ]);
            this.$store.dispatch('intents/NEW');
        },
    };
</script>



// WEBPACK FOOTER //
// IntentsNew.vue?781769ce